"use client";

import { useRouter } from "next/navigation";
import { forumPath } from "./ForumService";
import { PenSquare } from "lucide-react";
import { Button } from "@/app/_module/components/ui/button";
import { useForumAccess } from "../hooks/useForumAccess";

// "New post" from inside a room: opens the composer with that room preselected
// (the submit page reads ?category=slug). Same write gate as the hero button.
export function NewPostButton({ categorySlug, className = "" }: { categorySlug?: string; className?: string }) {
  const router = useRouter();
  const { requireWrite } = useForumAccess();
  const go = () => requireWrite(() => router.push(forumPath(`/submit${categorySlug ? `?category=${encodeURIComponent(categorySlug)}` : ""}`)));
  return (
    <Button size="sm" className={`h-9 gap-1.5 px-3.5 ${className}`} onClick={go}>
      <PenSquare className="h-3.5 w-3.5" />
      New post
    </Button>
  );
}
